import Layout from '../views/layout/Layout'
import RouteView from '../views/layout/RouteView'

const operationsToolsRoutes = {
  path: '/operationsTools',
  component: Layout,
  redirect: '/operationsTools/materialTools/materialReview',
  defaultPath: '/operationsTools/materialTools/materialReview',
  name: 'operationsTools',
  meta: { title: '运营工具', icon: 'business-center', alwaysShow: true },
  children: [
    {
      path: 'materialTools',
      name: 'materialTools',
      component: RouteView,
      meta: { title: '素材工具', icon: 'customer-list' },
      children: [
        {
          path: 'materialReview',
          alias: '/businessCenter/fengkongManager/qiancMaterialManager',
          name: 'qiancMaterialManager',
          morePath: '/operationsTools/materialTools/materialReview',
          component: () => import('@/views/planclick/qiancMaterialManager/index'),
          meta: { title: '千川素材预审', icon: 'customer-list' }
        },
        {
          path: 'viralFission',
          alias: '/businessCenter/fengkongManager/nuclearFissionList',
          name: 'nuclearFissionList',
          morePath: '/operationsTools/materialTools/viralFission',
          component: () => import('@/views/planclick/nuclearFissionManager/index'),
          meta: { title: '千川爆款裂变', icon: 'customer-list' }
        }
      ]
    },
    {
      path: 'riskManagement',
      name: 'riskManagement',
      component: RouteView,
      meta: { title: '风控管理', icon: 'adversiter-irregular-list' },
      children: [
        {
          path: 'qianchuanViolations',
          alias: '/businessCenter/fengkongManager/qiancIrregularManager',
          name: 'qiancIrregularManager',
          morePath: '/operationsTools/riskManagement/qianchuanViolations',
          component: () => import('@/views/planclick/qiancIrregularManager/index'),
          meta: { title: '千川违规记录', icon: 'adversiter-irregular-list' }
        },
        {
          path: 'allProductViolation',
          alias: '/businessCenter/fengkongManager/mediaViolationCenter',
          name: 'mediaViolationCenter',
          morePath: '/operationsTools/riskManagement/allProductViolation',
          component: () => import('@/views/planclick/mediaViolationCenter/index'),
          meta: { title: '全产品违规中心', icon: 'adversiter-irregular-list' }
        }
      ]
    }
  ]
}

export default operationsToolsRoutes



// WEBPACK FOOTER //
// ./src/router/operations-tools.js